import React from 'react';
import styled from 'styled-components';
import {currentResource, labels} from '../../../../../../../util/utils';
import {documentTypes} from '../../../../../../../util/uiconstants';
import RiskPills from '../../../../../RiskPills';
import EllipsesControl from '../../../../../EllipsesControl/EllipsesControl';
import AccountName from './AccountName';

export default function AccountsRisksCellRenderer(params) {
	const data = params.data;
	const parentValue = params.value;
	const childValue = params.value;

	let relatedDocuments = [];
	if (data && data.relatedDocuments && data.relatedDocuments.length > 0) {
		relatedDocuments = data.relatedDocuments.filter((doc) => doc.documentTypeID === documentTypes.ALRA_INDIVIDUAL);
	}

	const parentRow = data && data.path && data.path.length === 1 && (
		<AccountName
			accountId={data?.id}
			relatedDocuments={relatedDocuments}
			name={parentValue?.split('|')[1]}
			hasEstimate={data?.hasEstimate}
			executionTypeId={data?.executionTypeId}
			createDocIfNotExist
		/>
	);
	return parentRow ? parentRow : <ChildRow risk={data.risk} value={childValue} />;
}

export function ChildRow({risk = null, value}) {
	return risk !== null ? <RelatedRisks risk={risk} /> : <NoRisksRelated value={value} />;
}

export function RelatedRisks({risk, fromAssertion = false}) {
	let riskList = [];
	if (fromAssertion) {
		riskList.push(risk.risk);
	} else {
		riskList.push(risk);
	}

	return (
		<StyledRelatedRisks className="StyledRelatedRisks">
			{riskList.length > 0 && (
				<RiskPills
					risks={riskList}
					riskTypeLabels={currentResource.riskTypes}
					relatedRisksLabel={labels.relatedRisks}
					showTooltip={false}
					className={'RiskPillsContainer'}
				/>
			)}
			<section className="RiskNameLabelWrapper">
				<EllipsesControl
					content={fromAssertion ? risk.risk.riskName : risk.riskName}
					tooltip={fromAssertion ? risk.risk.riskName : risk.riskName}
					noOfLines={1}
				/>
			</section>
		</StyledRelatedRisks>
	);
}

export function NoRisksRelated({value}) {
	return <StyledNoRisksRelated className="StyledNoRisksRelated">{value}</StyledNoRisksRelated>;
}

const StyledNoRisksRelated = styled.section`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	font-size: var(--px-14);
	font-weight: 300;
	line-height: var(--px-24);
	color: var(--neutrals-800);
`;

const StyledRelatedRisks = styled.section`
	display: flex;
	align-items: center;
	width: 100%;
	.RiskPillsContainer {
		display: inline-flex;
		margin-right: var(--px-24);
		height: var(--px-24);
		align-items: center;
		.motif-dropdown-portal {
			display: inline-flex;
			.motif-dropdown-trigger {
				display: inline-flex;
			}
		}
		svg {
			width: var(--px-16);
			height: var(--px-16);
			vertical-align: middle;
			color: var(--neutrals-800);
			height: inherit;
		}
		.risk-types {
			.flash-icon {
				.motif-icon {
					svg {
						height: inherit !important;
					}
				}
			}
			.risk-type-abbreviations {
				min-width: var(--px-20) !important;
			}
		}
	}
	.RiskNameLabelWrapper {
		display: inline-flex;
		font-size: var(--px-12);
		font-weight: 300;
		line-height: var(--px-20);
		width: 85%;
		color: var(--neutrals-700);
	}
`;
